import createLanding from './actions/createLanding';
import getLanding from './actions/getLanding';
import landingsList from './actions/landingsList';
import updateLanding from './actions/updateLanding';
import getLandings from './getters/getLandings';
import uploadLandings from './mutations/uploadLandings';

const actions = {
    landingsList,
    getLanding,
    createLanding,
    updateLanding
};

const mutations = {
    uploadLandings
};

const getters = {
    getLandings
};

export default { actions, mutations, getters };
